import { assertNever } from 'utils';
import { JobType, } from './types';
import { calcZontMapStats, calcZontTrackAndIcons, zontCalcGraph, } from './calculate-functions';
export async function runJob(job, requestSender) {
    switch (job.type) {
        case JobType.track:
            return await calcZontTrackAndIcons(job.raw_data);
        case JobType.map_stats:
            return await calcZontMapStats(job.gps, job.device, job.time);
        case JobType.zont_graph:
            return await zontCalcGraph(job.requests, requestSender);
        default:
            assertNever(job);
    }
}
